import { isObject } from 'lodash'
import { createCallCellRender } from '../feature/call-cell-render'
import { createOperationColumn } from '../feature/operation-render'
import { createCopyCellRender } from '../feature/copy-cell-render'
import { createButtonOptionsRender } from '../feature/button-options-render'
import { createTextFlexColumnConfig } from '../feature/text-flex-render'
import { transformTipsOptions } from '../feature/transform-tips-options'
import { updateColumnWidth, table2ColumnWidthAmend } from './width'

export function customRender(col, options) {
  const {
    drawColumnOptions,
    updateColumnsOpt = {},
    vm,
    localStoreColumnsOpt,
    localStorePreColumnsOpt,
    buttonOptions = {},
    textFlexWidgetCols,
    permission,
    headerTipOptions = {}
  } = options
  const { option } = vm.$props.tableConfig
  const { callNumberKey = 'callNumberWidget' } = option || {}
  const { key, children = [], sortKeys, rowCellRender } = col
  const drawOption = (drawColumnOptions && drawColumnOptions[key]) || {}
  const mergeColumn = updateColumnsOpt[key]
  const storeColumn = localStoreColumnsOpt[key]
  const preColumn = localStorePreColumnsOpt[key]
  const buttonOption = buttonOptions[key]
  const CALL = 'call'

  // 拨打电话。兼容历史配置，支持一行多个列配置拨打电话功能
  if ((key === callNumberKey || col.widgetType === CALL) && !rowCellRender) {
    col.rowCellRender = createCallCellRender({ vm })
    col.showOverflowTooltip = true
    col.__innerCellRender = true
  }

  // 复制功能
  if (col.widgetType && col.widgetType != CALL && !rowCellRender) {
    col.rowCellRender = createCopyCellRender({vm})
    col.showOverflowTooltip = true
    col.__innerCellRender = true
  }

  // 气泡,调整的目的是为了解决支持表格配置工具富文本
  let tipsOpions = {}
  if (Object.values(headerTipOptions).length || col.headerTip){
    const _headerTipOptions = {
      ...(headerTipOptions || {}),
    }

    if(col.headerTip && !headerTipOptions[col.key]) {
      _headerTipOptions[col.key] = () => col.headerTip
    }

    tipsOpions = transformTipsOptions(col, _headerTipOptions)
  }


  // 判断是否更新了配置
  updateColumnWidth(options, col)

  // query-table, buttonOptions 适配
  if (buttonOption && !rowCellRender) {
    col.rowCellRender = createButtonOptionsRender(buttonOption, { vm, permission })
    col.showOverflowTooltip = true
    col.__innerCellRender = true
  }

  let column = {
    ...tipsOpions,
    ...col,
    ...(preColumn || {}),
    ...drawOption,
    ...(storeColumn || {}),
    ...(mergeColumn || {}),
    children: (children || []).map(col => customRender(col, options)),
  }
  // 伸缩部件功能
  if (col.textFlexWidget === true) {
    const textFlexWidgetColumnConfig = createTextFlexColumnConfig(col, vm.data, drawOption, options)
    Object.assign(column, textFlexWidgetColumnConfig, {
      showOverflowTooltip: drawOption.showOverflowTooltip !== false
    })
    textFlexWidgetCols.push(col)
  }
  Object.assign(column, {
    sortable: sortKeys && sortKeys.length === 2 ? 'custom' : column.sortable,
  })
  if (column.width) {
    column.width = table2ColumnWidthAmend(column.width)
  }
  return column
}

export function mergeColumns(columns, options) {
  const { operation } = options
  const _columns = columns.reduce((pre, col) => {
    pre = pre.concat({
      ...customRender(col, options)
    })
    return pre
  }, [])

  // 格式化自定义操作列
  if (_columns.length > 0 && isObject(operation) && Object.keys(operation).length > 0) {
    const operationColumn = createOperationColumn(options)
    _columns.unshift(operationColumn)
  }
  return _columns
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/config/column.js